// libs
import React, { useCallback } from 'react'
import ItemGroupHeader from 'src/components/item_group_header/item_group_header'

// interfaces / constants

// components
import BannerFeed, {
  EventBannerGroup
} from 'src/components/feed/layouts/banner_feed/banner_feed'
import FeedWrapper from 'src/containers/smart_components/list_wrapper/feed_wrapper'

// helpers
import LoadingSpinnerWrapper from 'src/components/loading_spinner/loading_spinner_wrapper'
import { useIsEventCreationEnabled } from 'src/hooks/useIsEventCreationEnabled'
import { textResources } from 'src/lang/de'
import { useGetRenderEventCreate } from './hooks'

interface IProps {
  getNextPage: () => void;
  isPostCreateOpen?: boolean;
  loading: boolean;
  eventFeedData: EventBannerGroup[];
  moreEvents: EventBannerGroup[];
  onVisibleChange?: (id: string, inView: boolean) => void
}

const CategorizedEventFeed: React.FC<IProps> = ({
  getNextPage,
  isPostCreateOpen = false,
  loading,
  eventFeedData,
  onVisibleChange,
  moreEvents
}) => {
  const isEventCreationEnabled = useIsEventCreationEnabled()

  const renderPostCreate = useGetRenderEventCreate(isPostCreateOpen)

  const renderFeedTitle = useCallback(
    () => (
      <ItemGroupHeader
        title={textResources.shared.hereIsMore}
        subtitle={textResources.eventfeed.relatedContentSubtitle}
        spacing
      />
    ),
    []
  )

  return (
    <LoadingSpinnerWrapper isLoading={loading && !eventFeedData}>
      <FeedWrapper
        getNextPage={getNextPage}
        initialLoad={false}
      >
        <BannerFeed
          groups={eventFeedData}
          isLoading={loading}
          renderPostCreate={isEventCreationEnabled ? renderPostCreate : undefined}
          showGroupLabels
          showEmptyFeed={false}
          showAllTopLink
          onVisibleChange={onVisibleChange}
        />
        <BannerFeed
          groups={moreEvents}
          showGroupLabels={false}
          isLoading={loading}
          renderFeedTitle={renderFeedTitle}
          onVisibleChange={onVisibleChange}
        />
      </FeedWrapper>
    </LoadingSpinnerWrapper>
  )
}

CategorizedEventFeed.displayName = 'CategorizedEventFeed'

export default CategorizedEventFeed
